function copy() {
    var id = this.getAttribute('data-index');
    
    // Get the value from hidden element with resource URL
    var copyText = document.querySelector( "#resource-url-" + id ).value;
    
    // Create a hidden input and set value to resource URL
    var tempInput = document.createElement("input");
    tempInput.style = "position: absolute; left: -1000px; top: -1000px";
    tempInput.value = copyText;
    document.body.appendChild(tempInput);
    
    // Select hidden input value, copy and then remove it
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);

    console.log(id);

    // Temporarily display notification
    var notification = document.querySelector( "#resource__copy-notification-" + id );
    notification.classList.add( 'resource__copy-notification--active' );

    // Remove notification class
    setTimeout( function() {
        notification.classList.remove( 'resource__copy-notification--active' );
    }, 3000 );
}

var copyButtons = document.querySelectorAll('.js-resource-copy');

for ( var i = 0; i < copyButtons.length; i++ ) {
    copyButtons[i].addEventListener( 'click' , copy );
}